import { countryIsEea } from '@studyportals/static-domain-data/countries/country-is-eea';
import { countryGetIdFromIsoCode } from '@studyportals/static-domain-data/countries/country-get-id-from-iso-code';

export class CountryRepository {
	public isCountryEEA(nationality_country_iso: string): boolean {
		const countryId = countryGetIdFromIsoCode(nationality_country_iso);
		return countryId == null ? false : this.isCountryEEAById(+countryId);
	}

	public isCountryEEAById(nationality_country_id: number): boolean {
		return countryIsEea(`${nationality_country_id}`);
	}

	public getEEARegionId(): number {
		return 38;
	}
}
